import actionTypes from '../constants/action-types';

const siteReset = () => ({
  type: actionTypes.SITE_RESET,
});

export default siteReset;
